import { api } from './api.ts';

/** Les sept couleurs de départ en usage sur les parcours français, et le
 *  pigment que chacune porte à l'écran.
 *
 *  Les couleurs réelles des piquets, pas celles du thème : c'est la seule
 *  famille de teintes de l'application qui ne lui appartient pas. Un départ
 *  blanc doit être blanc, même sur une carte crème. */
export const COULEURS_DEPART = {
    blanc: { mot: 'Blanc', pigment: '#f8f8f6', encre: '#1f2420' },
    jaune: { mot: 'Jaune', pigment: '#e8c33a', encre: '#2b2410' },
    bleu: { mot: 'Bleu', pigment: '#2f6fb5', encre: '#ffffff' },
    rouge: { mot: 'Rouge', pigment: '#c0392b', encre: '#ffffff' },
    orange: { mot: 'Orange', pigment: '#e8871e', encre: '#2b1c08' },
    vert: { mot: 'Vert', pigment: '#2f8b4e', encre: '#ffffff' },
    noir: { mot: 'Noir', pigment: '#1b1b1b', encre: '#ffffff' },
} as const;

export type CouleurDepart = keyof typeof COULEURS_DEPART;

export interface Licence {
    /** Sans espaces, en majuscules : c'est ce qu'encode le code-barres. */
    number: string;
    category: string | null;
    season: string | null;
    clubName: string | null;
    clubNumber: string | null;
    subscriber: boolean;
    ranking: string | null;
    teeColour: CouleurDepart | null;
    updatedAt: string;
}

export type LicenceDraft = Omit<Licence, 'updatedAt'>;

/** `null` quand le joueur n'en a pas saisi : ce n'est pas une erreur. */
export const getLicence = () =>
    api<{ licence: Licence | null }>('/me/licence').then((r) => r.licence);

export const saveLicence = (body: LicenceDraft) =>
    api<{ licence: Licence }>('/me/licence', { method: 'PUT', body }).then((r) => r.licence);

export const deleteLicence = () => api<void>('/me/licence', { method: 'DELETE' });

/** « 123456789 » → « 123 456 789 ».
 *
 *  Le groupement par trois est celui de la carte fédérale, et c'est ainsi
 *  qu'on lit un numéro à voix haute au starter. Il est rendu à l'AFFICHAGE
 *  seulement : le code-barres et la base gardent la forme compacte, sans quoi
 *  deux écritures du même numéro cohabiteraient. */
export const numeroLisible = (n: string): string =>
    (/^\d+$/.test(n) ? n.replace(/(\d{3})(?=\d)/g, '$1 ') : n);
